//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import * as trackedSourcesApi from '@apis/tracked-sources/trackedSourcesApi';
import { createNgApiAdapterService, GetNgApiAdapterType } from 'app/angular-apis/createNgApiAdapter';

const trackedSourcesApiService = createNgApiAdapterService(trackedSourcesApi);
export type TrackedSourcesApiService = GetNgApiAdapterType<typeof trackedSourcesApiService>;

// Backwards compatibility: Use the old service name
angular.module('curalate').service('TrackedSourcesApiService', trackedSourcesApiService);
